import { EMPTY_LIST } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { getIsApplicantArchivable } from '../RentalPortalApplicants.utils'

import {
  APPLICANT_BOARD_COLUMN_ORDER,
  QA_NAME_APPLICANT_BOARD,
} from './RentalPortalApplicantBoard.constants'
import { getApplicantsByStage } from './RentalPortalApplicantBoard.utils'
import { RentalPortalApplicantBoardColumn } from './RentalPortalApplicantBoardColumn'

import * as styles from './RentalPortalApplicantBoard.module.css'

function RentalPortalApplicantBoard({
  emptyState,
  getActions,
  getIsItemSelectable = getIsApplicantArchivable,
  hasHandoff,
  hasSelection,
  isListingScoped,
  isLoading,
  items,
  selected,
  selectNotAllowedTooltip,
  stageTotals,
  onCallAction,
  onClickCard,
  onSelectCard,
  onSelectColumn,
  onShowMore,
}) {
  const applicantsByStage = getApplicantsByStage(isLoading ? EMPTY_LIST : items)

  const selectedIds = hasSelection
    ? selected.map(applicant => applicant.id)
    : EMPTY_LIST

  const qaProps = getQaSelector({ value: QA_NAME_APPLICANT_BOARD })

  return (
    <div {...qaProps} className={styles.RentalPortalApplicantBoard}>
      {!isLoading && items.length === 0 ? emptyState : null}
      <div className={styles.columns}>
        {APPLICANT_BOARD_COLUMN_ORDER.map(stage => (
          <RentalPortalApplicantBoardColumn
            getActions={getActions}
            getIsItemSelectable={getIsItemSelectable}
            hasHandoff={hasHandoff}
            hasSelection={hasSelection}
            isListingScoped={isListingScoped}
            isLoading={isLoading}
            items={applicantsByStage[stage]}
            key={stage}
            selectedIds={selectedIds}
            selectNotAllowedTooltip={selectNotAllowedTooltip}
            stage={stage}
            total={stageTotals?.[stage]}
            onCallAction={onCallAction}
            onClickCard={onClickCard}
            onSelectCard={onSelectCard}
            onSelectColumn={onSelectColumn}
            onShowMore={onShowMore}
          />
        ))}
      </div>
    </div>
  )
}

export default RentalPortalApplicantBoard
